import { html } from "@microsoft/fast-element";
/**
 * The template for the {@link @fabric-msft/fabric-web#(TableCell:class)} component.
 * @public
 */
export function tableCellTemplate() {
    return html `
    <template class="table-cell" part="table-cell">
      <div part="cell-content" class="cell-content" role="cell">
        <slot name="before"></slot>
        <slot></slot>
        <slot name="after"></slot>
      </div>
    </template>
  `;
}
export const template = tableCellTemplate();
//# sourceMappingURL=table-cell.template.js.map